module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd-header"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "wrap flex"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('router-link', {
    staticClass: "index",
    class: {
      actived: _vm.currentPath == '/'
    },
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('router-link', {
    class: {
      actived: _vm.currentPath == '/settle'
    },
    attrs: {
      "to": "/settle"
    }
  }, [_vm._v("个人/机构入驻")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/logo.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d258f79e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/hd-header.vue
// module id = 372
// module chunks = 1